import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InspectionModelListPageComponent } from '../pages/list.component';
import { InspectionModelDetailPageComponent } from '../pages/detail.component';
import { InspectionModelNewPageComponent } from '../pages/new.component';
import { InspectionModelStatusPageComponent } from '../pages/status.component';
import { InspectionModelEditPageComponent } from '../pages/edit.component';
import { InspectionModelImportModelSectionsPageComponent } from '../pages/model-sections.component';
import { ImportSectionIndexPageComponent } from '../../shared/pages/importsections/index';
import {
  ImportPointIndexPageComponent,
  ImportPointsModelSectionsPageComponent,
  ImportPointsModelPointsPageComponent
} from '../../shared/pages/importpoints/index';

import { environment } from '../../../environments/environment';
import { PermissionGuard } from '../../utils/permission.guard';
import { CurrentUserResolver } from '../../utils/currentPerson.resolver';
import { InspectionModelChildrenListPageComponent } from '../pages/children-list.component';

const appRoute = environment.applicationRoute;
const templatesRoute = appRoute + '/templates';

const routes: Routes = [
  {
    path: '',
    resolve: { currentPerson: CurrentUserResolver },
    children: [
      {
        path: templatesRoute,
        component: InspectionModelListPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: `${templatesRoute}/parents`,
        component: InspectionModelListPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template', type: 'parents' }
      },
      {
        path: `${templatesRoute}/children`,
        component: InspectionModelListPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template', type: 'children' }
      },
      { path: templatesRoute + '/new', component: InspectionModelNewPageComponent },
      { path: templatesRoute + '/new/:type', component: InspectionModelNewPageComponent },
      {
        path: templatesRoute + '/:inspectionId',
        component: InspectionModelDetailPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      {
        path: templatesRoute + '/:inspectionId/templates',
        component: InspectionModelChildrenListPageComponent,
        canActivate: [PermissionGuard],
        data: { permission: 'manage.template' }
      },
      { path: templatesRoute + '/:inspectionId/status', component: InspectionModelStatusPageComponent },
      { path: templatesRoute + '/:inspectionId/edit', component: InspectionModelEditPageComponent },
      { path: templatesRoute + '/:targetId/addsection', component: ImportSectionIndexPageComponent },
      {
        path: templatesRoute + '/:targetId/addsection/:modelId',
        component: InspectionModelImportModelSectionsPageComponent
      },
      {
        path: templatesRoute + '/:targetId/sections/:sectionId/addpoint/:modelId',
        component: ImportPointsModelSectionsPageComponent
      },
      { path: templatesRoute + '/:targetId/sections/:sectionId/addpoint', component: ImportPointIndexPageComponent },
      {
        path: templatesRoute + '/:targetId/sections/:sectionId/addpoint/:modelId/:modelSectionId',
        component: ImportPointsModelPointsPageComponent
      },
      {
        path: templatesRoute + '/:targetId/sections/:sectionId/folders/:folderId/addpoint/:modelId',
        component: ImportPointsModelSectionsPageComponent
      },
      {
        path: templatesRoute + '/:targetId/sections/:sectionId/folders/:folderId/addpoint',
        component: ImportPointIndexPageComponent
      },
      {
        path: templatesRoute + '/:targetId/sections/:sectionId/folders/:folderId/addpoint/:modelId/:modelSectionId',
        component: ImportPointsModelPointsPageComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InspectionModelRoutingModule {}
export const routedComponents = [
  InspectionModelNewPageComponent,
  InspectionModelListPageComponent,
  InspectionModelDetailPageComponent,
  InspectionModelStatusPageComponent,
  InspectionModelEditPageComponent,
  ImportSectionIndexPageComponent,
  InspectionModelImportModelSectionsPageComponent,
  ImportPointIndexPageComponent,
  ImportPointsModelSectionsPageComponent,
  ImportPointsModelPointsPageComponent,
  InspectionModelChildrenListPageComponent
];
